// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "javascripts/" + {"150":"clanwars","424":"patrols","504":"treasury"}[chunkId] + ".chunk.js";
};